<template>
    <div>
        <div class="pdt">
            <table id="productDetailTable">
                <thead>
                    <tr>
                        <th class="name">商品名</th>
                        <th>価格<br>（税抜）</th>
                        <template v-if="showCosts">
                            <th>原価</th>
                            <th>原価率</th>
                        </template>
                        <th>初回売上日</th>
                        <th>ROAS</th>
                        <th>売上</th>
                        <th>広告費</th>
                    </tr>
                </thead>
                <tbody>
                    <tr v-for="product in productLists" :key="product.id">
                        <td class="name">
                            【{{ product.id }}<Icon v-if="product.is_set_product" title="セット商品">
                                dice-multiple-outline</Icon>】{{ product.name }}
                        </td>
                        <td class="ta-c">{{ product.price | priceLocaleString }}</td>

                        <template v-if="showCosts">
                            <td class="ta-c">{{ product.product_cost | priceLocaleString }}</td>

                            <template v-if="product['costs_change_flg'] == 1">
                                <td v-on:click="openProductMaster(product)" class="ta-c"><span
                                        class="costRateIcon">■</span>{{
                                            getCostRate(product.price,
                                                product.product_cost) }}%</td>
                            </template>
                            <template v-else>
                                <td class="ta-c">{{ getCostRate(product.price, product.product_cost) }}%</td>
                            </template>
                        </template>

                        <td class="ta-c">{{ orderedAt(product.ordered_at) }}</td>
                        <td class="ta-c">
                            <template v-if="getSummary(product.id, 'roas') > 0">
                                {{ getSummary(product.id, "roas") | percentDisp }}
                            </template>
                            <template v-else>-</template>
                        </td>
                        <td class="ta-c">{{ getSummary(product.id, "sales") | priceLocaleString }}</td>
                        <td class="ta-c">{{ getSummary(product.id, "ads") | priceLocaleString }}</td>
                    </tr>
                </tbody>
            </table>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        productLists: Array,
        summaries: Array,
        showCosts: Boolean,
        showCostsDev: Boolean,
    },
    methods: {
        getSummary(id, column) {
            var product = this.summaries.find(product => product.id == id && !product.is_group);
            if (product === null) {
                return "";
            }
            if (product === undefined) {
                return "";
            }
            return product[column];
        },
        getCostRate(price, product_cost) {
            var cost_rate = 0;
            if (price != 0) {
                cost_rate = Math.round(product_cost / price * 100);
            }
            return cost_rate;
        },
        orderedAt(ordered_at) {
            if (ordered_at == "") {
                return "実績なし";
            }
            return ordered_at;
        },
        // 商品マスタを別タブで開く
        openProductMaster(item) {
            var url = "/product_master?";

            // 商品グループ
            if (item["is_group"] === 1) {
                url += "&targetId=" + item["id"];
            }
            else {
                url += "&productId=" + item["id"];
            }

            url += "&productName=" + item["name"];

            window.open(url, "_blank");
        },
    },

}
</script>

<style scoped lang="sass">
// スクロール表示
.pdt
    height: 250px;
    overflow-y: scroll;
    &::-webkit-scrollbar
        width: 4px
        border-radius: 2px
        background-color: #c0c0c0
    &::-webkit-scrollbar-thumb
        border-radius: 2px
        background-color: $mainColor
// テーブルデザイン
#productDetailTable
    thead
        th
            background-color: $mainColor
            border: 1px solid $mainColor
            color: #fff
            padding: 10px 5px
            position: sticky
            top: 0;
            line-height: 20px
            // スクロール時、ヘッダーの後ろから文字がチラ見えするの防止
            // （枠線がスクロースされ消えてしまうため追加表示）
            &:before
                content: "";
                position: absolute;
                top: -1px;
                left: -1px;
                width: 100%;
                height: 100%;
                border: 1px solid $mainColor;
    tbody
        tr
            background: $whiteColor
            border: 1px solid $mainColor
        td
            border: 1px solid $mainColor
            padding: 10px 5px
            line-height: 20px
    .name
        width: 200px
    .ta-c
        text-align: center
        vertical-align: middle
    .costRateIcon
        color: red
        font-weight: bold

@include sp()
    .sp
        display: none !important
</style>